import BasicRepository from "./basicRepository";
import Client from "../client";
import {OctopusServerNodeResource} from "client/resources/octopusServerNodeResource";

class OctopusServerNodeRepository extends BasicRepository<OctopusServerNodeResource, OctopusServerNodeResource> {
    constructor(client: Client) {
        super("OctopusServerNodes", client);
    }
}

export default OctopusServerNodeRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/octopusServerNodeRepository.ts